export default __webpack_public_path__ + "static/media/check.8fb304cc.svg";